import apiFetch from '../../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'dossier/sales/fleetsCodes', method: 'GET', body: null, token: token })
}
